import api from './api';

export interface SucursalVenta {
    nroSuc: number;
    nombreSucursal: string;
    iniciarEn?: string;
    tipoSuc?: string;
}

export interface SucursalVentaSearchParams {
    searchTerm?: string;
    pageNumber: number;
    pageSize: number;
    nroSuc?: number;
    nombreSucursal?: string;
    tipoSuc?: string;
}

export interface SucursalVentaPagedResult {
    items: SucursalVenta[];
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
}

const sucursalesVentaService = {
    getSucursalesVenta: async (params: SucursalVentaSearchParams): Promise<SucursalVentaPagedResult> => {
        const response = await api.get<SucursalVentaPagedResult>('/api/SucursalesVenta', { params });
        return response.data;
    },

    getSucursalVenta: async (nroSuc: number): Promise<SucursalVenta> => {
        const response = await api.get<SucursalVenta>(`/api/SucursalesVenta/${nroSuc}`);
        return response.data;
    },

    createSucursalVenta: async (sucursal: SucursalVenta): Promise<SucursalVenta> => {
        const response = await api.post<SucursalVenta>('/api/SucursalesVenta', sucursal);
        return response.data;
    },

    updateSucursalVenta: async (nroSuc: number, sucursal: SucursalVenta): Promise<void> => {
        const payload = {
            nombreSucursal: sucursal.nombreSucursal ?? '',
            iniciarEn: sucursal.iniciarEn ?? null,
            tipoSuc: sucursal.tipoSuc ?? null
        };
        await api.put(`/api/SucursalesVenta/${nroSuc}`, payload);
    },

    deleteSucursalVenta: async (nroSuc: number): Promise<void> => {
        await api.delete(`/api/SucursalesVenta/${nroSuc}`);
    }
};

export default sucursalesVentaService;
